import { apiClient } from '../../helper/api';
import { SURPLUS_LINES_TAX_ESTIMATOR_TERMS_VERSION } from '../../helper/surplusLinesTaxEstimatorConfig';

export type TaxEstimatorEventType = 'calculate' | 'external_link';

export type LogTaxEstimatorUsagePayload = {
  stateId: number;
  eventType: TaxEstimatorEventType;
  transactionTypeId?: number | null;
  policyEffectiveDate?: string | null;
  endorsementEffectiveDate?: string | null;
  premiumAmount?: number | null;
  feesAmount?: number | null;
  calculatedResultsJson?: object | null;
  termsAcceptedVersion?: string;
};

export const logTaxEstimatorUsage = async (
  token: string,
  payload: LogTaxEstimatorUsagePayload,
): Promise<void> => {
  try {
    await apiClient('/TaxEstimator/logUsage', {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      }),
      body: JSON.stringify({
        stateId: payload.stateId,
        eventType: payload.eventType,
        transactionTypeId: payload.transactionTypeId ?? null,
        policyEffectiveDate: payload.policyEffectiveDate ?? null,
        endorsementEffectiveDate: payload.endorsementEffectiveDate ?? null,
        premiumAmount: payload.premiumAmount ?? null,
        feesAmount: payload.feesAmount ?? null,
        calculatedResultsJson: payload.calculatedResultsJson ?? null,
        termsAcceptedVersion:
          payload.termsAcceptedVersion ?? SURPLUS_LINES_TAX_ESTIMATOR_TERMS_VERSION,
      }),
    });
  } catch (error) {
    console.warn('Failed to log tax estimator usage', error);
  }
};
